module.exports = __webpack_public_path__ + "assets/player-potrait.31809ac5.svg";